import { useCallback, useContext } from 'react'

import './index.scss'
import ModalContext from '../../contexts/ModalContext/context'
import Icon from '../Icon'
import { useModal } from '../../hooks/useModal'
import Button from '../Button'
import { useTranslation } from 'react-i18next'
import { ICON } from '../Icon/data'

const Modal = () => {
  const { modal } = useContext(ModalContext)

  const { t } = useTranslation()
  const { closeModal } = useModal()

  const onExitClick = useCallback(() => {
    if (modal.onClose) {
      modal.onClose()
    }
    closeModal()
  }, [modal.onClose, closeModal])

  const onAcceptClick = useCallback(() => {
    if (modal.onAccept) {
      modal.onAccept()
    }
    closeModal()
  }, [modal.onAccept, closeModal])

  if (!modal.content) return null

  return (
    <div className="Modal__wrapper">
      <div className="Modal">
        <div className="Modal__header">
          <div className="Modal__header-label">{modal.header}</div>
          <div
            className="Modal__header-close"
            role="button"
            tabIndex={0}
            onClick={() => onExitClick()}
          >
            <Icon icon={ICON.CLOSE} />
          </div>
        </div>
        <div className="Modal__content">
          {modal.content}
        </div>
        <div className="Modal__buttons">
          {modal.customButtons ? modal.customButtons : (
            <>
              <Button
                label={modal.cancelButtonLabel ?? t('Cancel')}
                onClick={() => onExitClick()}
                type="tertiary"
              />
              <Button
                label={modal.acceptButtonLabel ?? t('Save')}
                onClick={() => onAcceptClick()}
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Modal
